import type { BrandConfig } from './src/contexts/BrandContext';
import type { AuthCenter } from './src/api/auth';

export const CMS_BRAND: BrandConfig = {
  name: 'CMS',
  colors: {
    primary: '#0D9488',
    secondary: '#1A1A1A',
  },
  documentMeta: {
    title: 'CMS',
    description: 'Center Management System',
  },
};

export const KUMON_BRAND: BrandConfig = {
  name: 'Kumon',
  colors: {
    primary: '#00A0E9',
    secondary: '#1A1A1A',
  },
  documentMeta: {
    title: 'Kumon',
    description: 'Kumon Center Management System',
  },
};

export function resolveBrand(center: AuthCenter | null | undefined): BrandConfig {
  return center?.is_kumon ? KUMON_BRAND : CMS_BRAND;
}
